import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ProductList from './ProductList';
import DynamicProductRows from './DynamicProductRows';
// import MyComponent from './MyComponent';
import ConnectionTest from './ConnectionTest';
import TestComponent from './TestComponent';
import LoginSystem from './LoginSystem';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <TestComponent/> */}
    {/* <ProductList/> */}
    {/* <MyComponent/> */}
    {/* <DynamicProductRows/> */}
    <LoginSystem/>
    {/* <ConnectionTest/> */}
    {/* <App /> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// https://quotereq.salasartech.com/f1.html